import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionAnalyzeLegacySubscriptions(
    $input: AnalyzeLegacySubscriptionsInput!
  ) {
    actionAnalyzeLegacySubscriptions(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      analysisData
    }
  }
  ${ErrorMessageInfo}
`;
